import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import zhTW from './locales/zh-TW'
import en from './locales/en'

Vue.use(VueI18n)

// 从 localStorage 获取保存的语言设置，如果没有则使用默认语言
const savedLocale = localStorage.getItem('locale') || 'zh'

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'zh',
  messages: {
    zh,
    'zh-TW': zhTW,
    en
  }
})

export default i18n

